/* eslint-disable consistent-return */
/* eslint-disable quote-props */
/**
*
* RedNavigation
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import onClickOutside from 'react-onclickoutside';

import getFrontendHost from 'getFrontendHost';

import setLanguageContent from 'helpers/setLanguageContent';
import throttle from 'helpers/throttle';

import getPageSlug from 'components/Templates/general/getPageSlug';
import Wrapper from 'components/Templates/dynamics/Wrapper';
import defaultLogo from 'assets/sample_logo_white.png';

import defaultTextValues from './defaultTextValues';


class RedNavigation extends React.Component {
  constructor(props) {
    super();

    this._isMounted = false;

    this.setNavigation = this.setNavigation.bind(this);
    this.showSubNav = this.showSubNav.bind(this);
    this.handleToggleNavVisibility = this.handleToggleNavVisibility.bind(this);
    this.checkIfNavFits = this.checkIfNavFits.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.navSectionRef = React.createRef();
    this.navWrapperRef = React.createRef();
    this.logoRef = React.createRef();
    this.buttonsWrapperRef = React.createRef();
    
    this.state = {
      isSubNavVisible: false,
      isMainNavVisible: false,
      navFits: true,
      thisNavigation: this.setNavigation(props)
    };
  }

  showSubNav(navId) {
    this.setState((state) => {
      if (state.isSubNavVisible === navId) return {
        isSubNavVisible: ''
      };

      return {
        isSubNavVisible: navId
      };
    });

  }

  handleToggleNavVisibility() {
    this.setState((prevState) => {
      return {
        isMainNavVisible: !prevState.isMainNavVisible,
        isSubNavVisible: ''
      };
    });
  }


  setNavigation(props) {

      const {
        commonData,
        navigations
      } = props ? props : this.props;

      const {
        componentPayload
      } = commonData;

      const {
        navigationId
      } = componentPayload;


    if (navigationId) {
      for (let i = 0; i < navigations.length; i++) {
        if (navigations[i].navigationId === navigationId) return navigations[i];
      }
    }

    return navigations[0];
  }

  
  checkIfNavFits = throttle(() => {
    if (!this._isMounted) return;

    const {
      thisNavigation
    } = this.state;

    if (!this.navSectionRef || !this.navSectionRef.current || !this.logoRef.current || !this.navSectionRef.current && thisNavigation && thisNavigation.length && this.navWrapperRef || !this.buttonsWrapperRef || !this.buttonsWrapperRef.current || !this.navWrapperRef || !this.navWrapperRef.current) return;
    
    const {
      commonProps
    } = this.props;

    const {
      frameRef
    } = commonProps;

    const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;

    const computedStyle = getComputedStyle(this.navSectionRef.current);

    let width = this.navSectionRef.current.getBoundingClientRect().width;

    let parseLeft = parseFloat(computedStyle.paddingLeft);

    if (isNaN(parseLeft)) parseLeft= 0;

    let parseButtons = parseInt(getComputedStyle(this.buttonsWrapperRef.current).getPropertyValue('width'));
    if (isNaN(parseButtons)) parseButtons = 0;

    let parseButtonsRight = parseInt(getComputedStyle(this.buttonsWrapperRef.current).getPropertyValue('right'));
    if (isNaN(parseButtonsRight)) parseButtonsRight = 0;

    width = width - parseLeft - parseButtonsRight;

    const isLogoHidden = frameWindow.getComputedStyle(this.logoRef.current, null).display;

    if (isLogoHidden) this.logoRef.current.style.display = 'block';

    let availableNavWidth = width - this.logoRef.current.getBoundingClientRect().width - this.buttonsWrapperRef.current.getBoundingClientRect().width - 30;

    let parseRightMarginLogo = parseFloat(getComputedStyle(this.logoRef.current).marginRight);
    if (isNaN(parseRightMarginLogo)) parseRightMarginLogo = 0;

    let parseLeftMarginLogo = parseFloat(getComputedStyle(this.logoRef.current).marginLeft);
    if (isNaN(parseLeftMarginLogo)) parseLeftMarginLogo = 0;

    let parseRightMarginButtons = parseFloat(getComputedStyle(this.buttonsWrapperRef.current).marginRight);
    if (isNaN(parseRightMarginButtons)) parseRightMarginButtons = 0;
    let parseLeftMarginButtons = parseFloat(getComputedStyle(this.buttonsWrapperRef.current).marginLeft);
    if (isNaN(parseLeftMarginButtons)) parseLeftMarginButtons = 0;

    availableNavWidth = availableNavWidth - parseLeftMarginButtons - parseRightMarginButtons - parseLeftMarginLogo - parseRightMarginLogo;

    const navWrapperWidth = this.navWrapperRef.current.getBoundingClientRect().width;

    const currentNavFits = availableNavWidth > navWrapperWidth;

    if (isLogoHidden) this.logoRef.current.style.display = '';

    this.setState({
      navFits: currentNavFits,
      isLogoHidden: isLogoHidden === 'none'
    });


  }, 5);

  handleClickOutside(event) {

    if (this.props.commonProps.isEditor || !this._isMounted || !event) return;
    
    if (this.navSectionRef.current.contains(event.target)) {
      return;
    }

    if (this.state.isMainNavVisible || this.state.isSubNavVisible) {
      this.setState({
        isMainNavVisible: false,
        isSubNavVisible: false
      });
    }
  }

  componentDidMount() {

    const {
      commonProps,
      commonData
    } = this.props;

    const {
      frameRef,
      isEditor
    } = commonProps;


    this._isMounted = true;

    const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;
    this.checkIfNavFits();

    if (!isEditor) {
      document.fonts.ready.then(() => {
        this.checkIfNavFits();
      });
    }

    frameWindow.addEventListener('resize', this.checkIfNavFits);
  }
  
  componentDidUpdate(prevProps) {

    
    const {
      commonData,
      viewPort,
      commonProps
    } = this.props;

    const {
      isEditor,
      isPreview
    } = commonProps;

    const {
      styling
    } = commonData;

    if (isEditor || isPreview) {

      const thisNavigation = this.setNavigation();

      if (JSON.stringify(thisNavigation) !== JSON.stringify(this.state.thisNavigation)) {
        this.setState({
          thisNavigation: thisNavigation
        }, () => {
          setTimeout(() => {
            this.checkIfNavFits();
          }, 100);
        });
      } else if ((isEditor || isPreview) && JSON.stringify(styling) !== JSON.stringify(prevProps.commonData.styling) || viewPort !== prevProps.viewPort) {
        setTimeout(() => {
          this.checkIfNavFits(true);
        }, 100);
        }
      }
    
  }

  componentWillUnmount() {

    const {
      commonProps
    } = this.props;

    const {
      frameRef
    } = commonProps;

     this._isMounted = false;
     const frameWindow = frameRef && document.querySelector(frameRef) && document.querySelector(frameRef).contentWindow ? document.querySelector(frameRef).contentWindow : window;

     frameWindow.removeEventListener('resize', this.checkIfNavFits);
  }


  

  render() {

    const {
      isSubNavVisible,
      isMainNavVisible,
      navFits,
      thisNavigation,
      isLogoHidden
    } = this.state;

    const {
      commonData,
      commonProps,
    } = this.props;
    
    const {
      componentPayload,
      sectionId
    } = commonData;


    const disableAutomaticStylePull = componentPayload.disableAutomaticStylePull;

    const {
      language,
      isEditor,
      pages,
      baseUrlTamplate,
      logo,
    } = commonProps;


    const thisBaseTemplateUrl = baseUrlTamplate ? baseUrlTamplate : '';

    const navigationContent = thisNavigation && thisNavigation.list && thisNavigation.list.length > 0 ? thisNavigation.list.map((navigation, i) => {


      const setSlug = getPageSlug(pages, navigation, thisBaseTemplateUrl);

      if (!setSlug) return;

      const navigationSubLinks = navFits && navigation.list && navigation.list.length > 0 && isSubNavVisible && navigation.linkId === isSubNavVisible ? navigation.list.map((subNav, b) => {


        const setSubSlug = getPageSlug(pages, subNav, thisBaseTemplateUrl);

        const {
          customUrl,
          newWindow
        } = subNav;

        return (
          <Wrapper
            {...commonProps}
            automaticStylePull={!disableAutomaticStylePull && !navFits}
            typeOfStyle={'subLink'}
            href={customUrl ? customUrl : setSubSlug}
            target={newWindow ? '_blank' : null}
            as={isEditor ? 'div' : 'a'}
            key={`RedNavigation-${thisNavigation.navigationId}-${b}`}
            onClickCallback={this.handleToggleNavVisibility}
            classes={subNav.classes}
            editorData={
              {
                editorType: 'subLink',
                ...commonData
              }
            }
          >
            {setLanguageContent(subNav, 'title', language)}
          </Wrapper>
        );
      }) : '';

      return (
        <Wrapper
          {...commonProps}
          automaticStylePull={!disableAutomaticStylePull && !navFits}
          typeOfStyle={ 'link'}
          href={navigation.list && navigation.list.length || isEditor ? '' : navigation.customUrl ? navigation.customUrl : setSlug}
          as={navigation.list && navigation.list.length > 0 || isEditor ? 'div' : 'a'}
          target={navigation.newWindow ? '_blank' : null}
          key={`RedNavigation-${thisNavigation.navigationId}-${i}`}
          handleClick={navigation.list ? this.showSubNav : null}
          classes={navigation.classes}
          clickValue={navigation.linkId}
          editorData={
            {
              editorType: 'link',
              ...commonData
            }
          }
        >
          {setLanguageContent(navigation, 'title', language)}
          {navFits && navigation.list && navigation.list.length > 0 && navigation.linkId === isSubNavVisible && isSubNavVisible ? (
            <Wrapper
              {...commonProps}              
              automaticStylePull={!disableAutomaticStylePull && !navFits}
              typeOfStyle={'subLinksWrapper'}
              editorData={
                {
                  editorType:'subLinksWrapper',
                  ...commonData
                }
              }
            >
              {navigationSubLinks}
            </Wrapper>
          ) : ''}
        </Wrapper>
      );
    }) : '';


    const navigationContentMobile = thisNavigation && thisNavigation.list && thisNavigation.list.length > 0 ? thisNavigation.list.map((navigation, i) => {


      const setSlug = getPageSlug(pages, navigation, thisBaseTemplateUrl);

      if (!setSlug) return;

      const navigationSubLinks = !navFits && navigation.list && navigation.list.length > 0 && isSubNavVisible && navigation.linkId === isSubNavVisible ? navigation.list.map((subNav, b) => {


        const setSubSlug = getPageSlug(pages, subNav, thisBaseTemplateUrl);

        const {
          customUrl,
          newWindow
        } = subNav;

        return (
          <Wrapper
            {...commonProps}
            automaticStylePull={!disableAutomaticStylePull && !navFits}
            typeOfStyle={'subLink'}
            href={customUrl ? customUrl : setSubSlug}
            target={newWindow ? '_blank' : null}
            as={isEditor ? 'div' : 'a'}
            onClickCallback={this.handleToggleNavVisibility}
            key={`RedNavigation-${thisNavigation.navigationId}-${b}`}
            classes={subNav.classes}
            editorData={
              {
                editorType: 'subLink',
                ...commonData
              }
            }
          >
            {setLanguageContent(subNav, 'title', language)}
          </Wrapper>
        );
      }) : '';


      return (
        <Wrapper
          {...commonProps}
          automaticStylePull={!disableAutomaticStylePull && !navFits}
          typeOfStyle={ 'linkNoLeftPadding'}
          href={navigation.list && navigation.list.length || isEditor ? '' : navigation.customUrl ? navigation.customUrl : setSlug}
          as={navigation.list && navigation.list.length > 0 || isEditor ? 'div' : 'a'}
          target={navigation.newWindow ? '_blank' : null}
          key={`RedNavigation-${thisNavigation.navigationId}-${i}`}
          onClickCallback={navigationSubLinks ? this.handleToggleNavVisibility : null}
          handleClick={navigation.list ? this.showSubNav : null}
          clickValue={navigation.linkId}
          classes={navigation.classes}
          editorData={
            {
              editorType: 'linkNoLeftPadding',
              ...commonData
            }
          }
        >
          {setLanguageContent(navigation, 'title', language)}
          {!navFits && navigation.list && navigation.linkId === isSubNavVisible && isSubNavVisible ? (
            <Wrapper
              {...commonProps}
              automaticStylePull={!disableAutomaticStylePull && !navFits}
              typeOfStyle={'subLinksWrapperVertical'}
              editorData={
                {
                  editorType: 'subLinksWrapperVertical',
                  ...commonData
                }
              }
            >
              {navigationSubLinks}
            </Wrapper>
          ) : ''}
        </Wrapper>
      );
    }) : '';


    return (
      <Wrapper
        {...commonProps}

        key={`RedNavigationWrapper-${isEditor ? navFits : ''}${sectionId}-${thisNavigation.navigationId}-${thisNavigation && thisNavigation.list && thisNavigation.list.length ? thisNavigation.list.length : 0}`}
        typeOfStyle={'wrapper'}
        editorData={
          {
            editorType: 'wrapper',
            ...commonData
          }
        }
        innerRef={this.navSectionRef}
      >
        {!navFits
          ? (
            <Wrapper
              {...commonProps}
              automaticStylePull={!disableAutomaticStylePull && !navFits}
              typeOfStyle={isMainNavVisible ? 'burgerClose' : 'burger'}
              handleClick={this.handleToggleNavVisibility}
              editorData={
                {
                  editorType: isMainNavVisible ? 'burgerClose' : 'burger',
                  ...commonData
                }
              }
            />
          ) : ''}


            <Wrapper
              {...commonProps}
              typeOfStyle={'logo'}
              backgroundImage={logo ? logo : defaultLogo}
              defaultUrl={'/'}
              editorData={
                {
                  editorType: 'logo',
                  ...commonData
                }
              }
              innerRef={this.logoRef}
            />
            <Wrapper
              {...commonProps}
              automaticStylePull={!disableAutomaticStylePull && !navFits}
              typeOfStyle={navFits ? 'navigationWrapper' : 'navigationWrapperHidden'}
              editorData={
               {
                  editorType:  navFits ? 'navigationWrapper' :  'navigationWrapperHidden',
                  ...commonData
                }
              }
              innerRef={this.navWrapperRef}
            >
              {navigationContent}
            </Wrapper>
  
            <Wrapper
              {...commonProps}
              automaticStylePull={!disableAutomaticStylePull && !navFits}
              typeOfStyle={navFits  || !navFits && !isMainNavVisible || navFits && isMainNavVisible ? 'navigationWrapperVerticalHidden' : 'navigationWrapperVertical'}
              editorData={
                {
                  editorType: navFits || !navFits && !isMainNavVisible || navFits && isMainNavVisible ?  'navigationWrapperVerticalHidden' : 'navigationWrapperVertical',
                  ...commonData
                }
              }
            >

              <Wrapper
                {...commonProps}
                automaticStylePull={!isLogoHidden}
                typeOfStyle={'logoMobile'}
                backgroundImage={logo ? logo : defaultLogo}
                onClickCallback={this.handleToggleNavVisibility}
                defaultUrl={'/'}
                editorData={
                  {
                    editorType: 'logoMobile',
                    ...commonData
                  }
                }
              />
              {navigationContentMobile}
              <Wrapper
                {...commonProps}
                automaticStylePull={!disableAutomaticStylePull && !navFits}
                typeOfStyle={'horizontalWrapperMobile'}
                
                editorData={
                    {
                      editorType: 'horizontalWrapperMobile',
                      ...commonData
                    }
                  }
              >
                <Wrapper
                  {...commonProps}
                  automaticStylePull={!disableAutomaticStylePull && !navFits}
                  type={'text'}
                  typeOfStyle={'buttonSecondaryMobile'}
                  defaultUrl={getFrontendHost()+'dashboard'}
                  onClickCallback={this.handleToggleNavVisibility}
                  target={'_parent'}
                  editorData={
                    {
                      editorType: 'buttonSecondaryMobile',
                      ...commonData
                    }
                  }
                />
                <Wrapper
                  {...commonProps}
                  automaticStylePull={!disableAutomaticStylePull && !navFits}
                  type={'text'}
                  typeOfStyle={'buttonPrimaryMobile'}
                  onClickCallback={this.handleToggleNavVisibility}
                  defaultUrl={'/register'}
                  target={'_parent'}
                  editorData={
                    {
                      editorType: 'buttonPrimaryMobile',
                      ...commonData
                    }
                  }
                />
              </Wrapper>
            </Wrapper>

    
     

        <Wrapper
          {...commonProps}
          typeOfStyle={'buttonWrapper'}
          innerRef={this.buttonsWrapperRef}
          editorData={
              {
                editorType: 'buttonWrapper',
                ...commonData
              }
            }
        >
          {' '}
          <Wrapper
            {...commonProps}
            typeOfStyle={'horizontalWrapper'}
            editorData={
                {
                  editorType: 'horizontalWrapper',
                  ...commonData
                }
              }
          >
            <Wrapper
              {...commonProps}
              type={'text'}
              typeOfStyle={'buttonSecondary'}
              defaultUrl={getFrontendHost()+'dashboard'}
              target={'_parent'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: 'buttonSecondary',
                  ...commonData
                }
              }
            />
            <Wrapper
              {...commonProps}
              type={'text'}
              typeOfStyle={'buttonPrimary'}
              defaultUrl={'/register'}
              target={'_parent'}
              defaultValues={defaultTextValues}
              editorData={
                {
                  editorType: 'buttonPrimary',
                  ...commonData
                }
              }
            />
          </Wrapper>
        </Wrapper>
      </Wrapper>
    );
  }
}


RedNavigation.propTypes = {
  commonData: PropTypes.object,
  openEditor: PropTypes.func,
  commonProps: PropTypes.object,
  navigations: PropTypes.array
};

export default onClickOutside(RedNavigation);
